import type { Level } from './levelHelpers'
import { LEVEL_ICON_COMPONENTS } from './levelIcons'
import LevelPopover from './LevelPopover'
import type { LevelPopoverOpenHandler, LevelTrackerLabels } from './levelTrackerTypes'

interface LevelBadgesProps {
  levels: Level[]
  earned: number
  labels: LevelTrackerLabels
  onPopoverOpen: LevelPopoverOpenHandler
}

/** One badge per level, filled once unlocked, with the "Level N of M unlocked" caption. */
export default function LevelBadges({ levels, earned, labels, onPopoverOpen }: LevelBadgesProps) {
  return (
    <div className='flex flex-col gap-2.5'>
      <div className='flex flex-wrap gap-3'>
        {levels.map((level, index) => {
          const number = index + 1
          const unlocked = number <= earned
          const Icon = LEVEL_ICON_COMPONENTS[level.icon]

          return (
            <LevelPopover
              key={number}
              title={labels.levelTitle(number, level.title)}
              description={level.description}
              ariaLabel={labels.badgeLabel(number, level.title, unlocked)}
              align='start'
              triggerClassName={`focus-visible:ring-cta grid size-9.5 cursor-pointer place-items-center rounded-full border-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&_svg]:size-4.5 ${
                unlocked ? 'border-success bg-success text-success-txt' : 'border-pending text-pending-txt bg-alt'
              }`}
              onOpen={(method) => onPopoverOpen(number, 'badge', method)}
            >
              <Icon aria-hidden='true' />
            </LevelPopover>
          )
        })}
      </div>
      <p className='text-secondary-txt text-left text-sm font-semibold'>
        {earned === 0 ? labels.unlockFirstLevel : labels.levelsUnlocked(earned, levels.length)}
      </p>
    </div>
  )
}
